// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0fb634ff","366":"3dcb6145","389":"5e19243f","453":"5a2c2e08","527":"0518067b","667":"37911c05","705":"de9cbe0d","732":"7f6da5d3","785":"4e564f56","850":"d4560796","854":"2eccedc6","977":"3e757eca"}[chunkId] + ".chunk.js";
};